export default function ResultsSection() {
  const results = [
    {
      value: "100%",
      label: "Financement CEE possible",
      icon: "ri-money-euro-circle-line"
    },
    {
      value: "25%",
      label: "Économies d'énergie",
      icon: "ri-leaf-line"
    },
    {
      value: "0€",
      label: "Avance de frais",
      icon: "ri-hand-coin-line"
    },
    {
      value: "500+",
      label: "Serres équipées",
      icon: "ri-plant-line"
    }
  ];

  const testimonials = [
    {
      name: "Jean-Pierre M.",
      location: "Producteur de tomates, Bretagne",
      text: "Depuis l'installation du système de déshumidification, nous avons réduit de 80% les problèmes de botrytis. La qualité de nos tomates s'est nettement améliorée et nos coûts de chauffage ont baissé de 20%.",
      rating: 5
    },
    {
      name: "Marie L.",
      location: "Horticultrice, Pays de la Loire",
      text: "Le financement CEE à 100% nous a permis d'équiper nos 2000m² de serres sans aucun investissement. L'équipe AIRPURE a géré toutes les démarches administratives. Installation impeccable et résultats immédiats.",
      rating: 5
    },
    {
      name: "François D.",
      location: "Maraîcher, Provence",
      text: "Excellent accompagnement du début à la fin. Les économies d'énergie sont au rendez-vous et nos cultures sont beaucoup plus saines. Le système de pilotage automatique est très pratique.",
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#4F8B3A] to-[#3a6b2a]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Results Stats */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Des Résultats Concrets</h2>
          <p className="text-xl text-white/90">
            Rejoignez des centaines d'exploitants qui ont déjà optimisé leurs serres
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-20">
          {results.map((result, index) => (
            <div 
              key={index} 
              className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${result.icon} text-3xl text-[#4F8B3A]`}></i>
              </div>
              <div className="text-5xl font-bold text-white mb-2">{result.value}</div>
              <div className="text-lg text-white/90">{result.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div>
          <h3 className="text-3xl font-bold text-white text-center mb-12">
            Témoignages de Nos Clients
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed italic">
                  "{testimonial.text}"
                </p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
